import React from 'react';
import TextBlock from 'components/common/helpMeDecide/TextBlock';
import withCriteria from 'components/common/helpMeDecide/withCriteria';
import { Guideline, RadioGroup } from '@insurancemenu/imenu-components-lib';
import { createStyles } from 'components/common/helpMeDecide/commonCriteriaStyles';
import { useRootStore } from 'store/rootStore';
import { observer } from 'mobx-react-lite';

const VisionCriteria2 = observer((): JSX.Element => {
  const classes = createStyles();
  const {
    browsingFilterStore: { getFilterRangeValue, onRangeFilterChange },
  } = useRootStore();

  const filterName = 'Eyeglass Lenses';

  // Values for radio buttons group
  const radioButtons = [
    {
      id: 'lenses-10',
      label: '$10',
      value: '10',
    },
    {
      id: 'lenses-25',
      label: '$25',
      value: '25',
    },
    {
      id: 'all',
      label: 'Show me all options',
      value: 'all',
    },
  ];

  return (
    <div>
      <TextBlock
        title="Choose Your Lens Copayment"
        subtitle="Choose $10 for lower out of pocket costs when accessing care or $25 for lower monthly premiums."
      />
      <RadioGroup
        label=""
        value={getFilterRangeValue(filterName)}
        radioButtons={radioButtons}
        className={classes.radioButtonGroup}
        onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
          onRangeFilterChange(filterName, e.target.value);
        }}
      />
      <Guideline
        simpleStyles
        labels={{
          opened: 'More information on copayments',
          closed: 'More information on copayments',
        }}
        className={classes.guidelineWrapper}
        content={
          <ul className={classes.guidelineList}>
            <li className={classes.guidelineItem}>
              This is the amount for standard plastic lenses covered once every calendar year.
            </li>
            <li className={classes.guidelineItem}>
              The standard plastic lens includes single vision, standard bifocal, standard trifocal and standard
              lenticular lens.
            </li>
            <li className={classes.guidelineItem}>
              If employees wish to have other lens options such as premium progressive lenses, this will be an
              additional copayment.
            </li>
            <li className={classes.guidelineItem}>
              Other lens options such as tint and UV coating will also have varying copayment amounts.
            </li>
          </ul>
        }
      />
    </div>
  );
});

export default withCriteria(VisionCriteria2, 2);
